"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FirstAidKit = function FirstAidKit(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M17.625 18.25H6.375c-.69 0-1.25-.56-1.25-1.25V9.5c0-.69.56-1.25 1.25-1.25h11.25c.69 0 1.25.56 1.25 1.25V17c0 .69-.56 1.25-1.25 1.25zm-1.875-5.625a.312.312 0 00-.313-.313h-2.5v-2.5a.312.312 0 00-.312-.312h-1.25a.312.312 0 00-.313.313v2.5h-2.5a.312.312 0 00-.312.312v1.25c0 .173.14.313.313.313h2.5v2.5c0 .172.14.312.312.312h1.25c.173 0 .313-.14.313-.313v-2.5h2.5c.172 0 .312-.14.312-.312v-1.25zm-.239-5h-.735a.39.39 0 01-.363-.246L13.8 5.85a.156.156 0 00-.145-.099h-3.31a.156.156 0 00-.145.098L9.587 7.38a.39.39 0 01-.363.246H8.49a.234.234 0 01-.218-.321l.807-2.018a1.25 1.25 0 011.16-.786h3.523c.511 0 .97.311 1.16.786l.808 2.018a.234.234 0 01-.218.321z"
  }));
};

var _default = (0, _react.forwardRef)(FirstAidKit);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FirstAidKit, "FirstAidKit", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/FirstAidKit.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/FirstAidKit.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9GaXJzdEFpZEtpdC50c3giXSwibmFtZXMiOlsiRmlyc3RBaWRLaXQiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsV0FBMkUsR0FBRyxTQUE5RUEsV0FBOEUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDbEY7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FEa0Y7QUFBQSxDQUFwRjs7ZUFTZSx1QkFBV0YsV0FBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxXIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBGaXJzdEFpZEtpdDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTcuNjI1IDE4LjI1SDYuMzc1Yy0uNjkgMC0xLjI1LS41Ni0xLjI1LTEuMjVWOS41YzAtLjY5LjU2LTEuMjUgMS4yNS0xLjI1aDExLjI1Yy42OSAwIDEuMjUuNTYgMS4yNSAxLjI1VjE3YzAgLjY5LS41NiAxLjI1LTEuMjUgMS4yNXptLTEuODc1LTUuNjI1YS4zMTIuMzEyIDAgMDAtLjMxMy0uMzEzaC0yLjV2LTIuNWEuMzEyLjMxMiAwIDAwLS4zMTItLjMxMmgtMS4yNWEuMzEyLjMxMiAwIDAwLS4zMTMuMzEzdjIuNWgtMi41YS4zMTIuMzEyIDAgMDAtLjMxMi4zMTJ2MS4yNWMwIC4xNzMuMTQuMzEzLjMxMy4zMTNoMi41djIuNWMwIC4xNzIuMTQuMzEyLjMxMi4zMTJoMS4yNWMuMTczIDAgLjMxMy0uMTQuMzEzLS4zMTN2LTIuNWgyLjVjLjE3MiAwIC4zMTItLjE0LjMxMi0uMzEydi0xLjI1em0tLjIzOS01aC0uNzM1YS4zOS4zOSAwIDAxLS4zNjMtLjI0NkwxMy44IDUuODVhLjE1Ni4xNTYgMCAwMC0uMTQ1LS4wOTloLTMuMzFhLjE1Ni4xNTYgMCAwMC0uMTQ1LjA5OEw5LjU4NyA3LjM4YS4zOS4zOSAwIDAxLS4zNjMuMjQ2SDguNDlhLjIzNC4yMzQgMCAwMS0uMjE4LS4zMjFsLjgwNy0yLjAxOGExLjI1IDEuMjUgMCAwMTEuMTYtLjc4NmgzLjUyM2MuNTExIDAgLjk3LjMxMSAxLjE2Ljc4NmwuODA4IDIuMDE4YS4yMzQuMjM0IDAgMDEtLjIxOC4zMjF6XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoRmlyc3RBaWRLaXQpO1xuIl19